<template>
  <div v-if="isShowPage" class="stored-value-money">
    <van-nav-bar :title="lang.title" :left-arrow="!$route.query.fromapp" @click-left="onClickLeft" />
    <div class="content">
      <!-- 表格 -->
      <table class="table" a="1">
        <tr>
          <th>{{ lang.type }}</th>
          <th>{{ lang.money }}</th>
          <th>{{ lang.date }}</th>
        </tr>
        <tr>
          <td>{{ lang.standard }}</td>
          <td v-for="(item, idx) in lang.info" :key="idx">
            <del>{{ item.price }}</del>
            <div class="center">{{ item.discountPrice }}</div>
            <div>{{ lang.salePrice }}</div>
          </td>
          <td class="time" v-for="item in lang.info" :key="item.itemName">
            {{ lang.sell_dish + item.effectiveDays + lang.day }}
            <br />
            {{ lang.rent_out + item.rentEffectiveDays + lang.day }}
            <br />
          </td>
        </tr>
        <tr v-if="JSON.stringify(lang.star) != '[]'">
          <td>{{ lang.Star }}</td>
          <td>
            <div class="center">{{ lang.sell_dish }}：{{ lang.star[0].discountPrice }}</div>
            <div class="pos">{{ lang.rent_out }}：{{ lang.star[1].discountPrice }}</div>
          </td>
          <td>
            <div class="center">{{ lang.sell_dish }}{{ lang.star[0].effectiveDays }}{{ lang.day }}</div>
            <div>{{ lang.rent_out }}{{ lang.star[1].rentEffectiveDays }}{{ lang.day }}</div>
          </td>
        </tr>
      </table>

      <!-- 間隙 -->
      <div class="interval"></div>
      <!-- 儲值數量和付款方式 -->
      <div class="bottom">
        <h3>{{ lang.stored_value }}</h3>
        <div class="num">
          <span class="number1">1</span>
          <span class="name">{{ lang.select_number }}</span>
        </div>
        <ul>
          <li @click="son(item, idx)" :class="idx == index ? 'selected' : ''" v-for="(item, idx) in lang.list" :key="idx">
            <div class="info">{{ item.propertyCoin + lang.wu_money }}</div>
            <div class="info">{{ lang.hk + item.money }}</div>
          </li>
        </ul>
        <div class="payment">
          <span class="number2">2</span>
          <span class="name">{{ lang.select_payment_way }}</span>
        </div>
        <div class="select">
          <div class="seltit">{{ lang.payment_way }}</div>
          <div class="pdBox">
            <van-radio-group v-model="radio" @change="radioChange">
              <!-- <section>
              <ul>
                <li v-for="item in pay" :class="item.attr == 'trans' ? 'linetrans' : ''" :key="item.id">
                  <span>
                    <img :src="item.img" alt="" :class="item.attr == 'paypal' ? 'palimg' : ''" />
                    <span>{{ item.text }}</span>
                  </span>
                  <van-radio class="paycol" checked-color="#ED1818" :name="item.attr" v-model="radio"></van-radio>
                </li>
              </ul>
            </section> -->
              <div class="pdFlex" @click="changeRad(`${lang.columns[0]}`)">
                <div>
                  <img style="width: 22px; height: 17px; margin-right: 12px" src="../assets/postCard.png" alt="##" />
                  <span>{{ lang.pdCre }} (VISA, Mastercard)</span>
                </div>
                <van-radio checked-color="#ED1818" :name="lang.columns[0]"></van-radio>
              </div>
              <div class="pdFlex" @click="changeRad(`${lang.columns[1]}`)">
                <img style="width: 96px;height: 21px;" src="../assets/pay01.png" alt="##" class="palimg" />
                <van-radio checked-color="#ED1818" :name="lang.columns[1]"></van-radio>
              </div>
              <!-- 支付宝支付 -->
              <div v-if="isAliPay" class="pdFlex" @click="changeRad(`${lang.columns[2]}`)">
                <div style="display: flex; align-items: center">
                  <img src="../assets/alipay@2x.png" alt="##" class="palimg" style="width: 22px; height: 22px; margin-right: 12px" />
                  <div class="ali-text">
                    <div>AlipayHK</div>
                    <div style="font-size: 12px; margin-top: 8px">({{ lang.alipayText }}）</div>
                  </div>
                </div>
                <van-radio checked-color="#ED1818" :name="lang.columns[2]"></van-radio>
              </div>
              <!-- 微信支付 -->
              <div v-if="isWePay" class="pdFlex" @click="changeRad(`${lang.columns[3]}`)">
                <div style="display: flex; align-items: center">
                  <img src="../assets/wechat@2x.png" alt="##" class="palimg" style="width: 22px; height: 22px; margin-right: 12px" />
                  <div class="ali-text">
                    <div>WeChat Pay HK</div>
                    <div style="font-size: 12px; margin-top: 8px">({{ lang.wePayText }})</div>
                  </div>
                </div>
                <van-radio checked-color="#ED1818" :name="lang.columns[3]"></van-radio>
              </div>
              <div class="pdFlex" @click="changeRad(`${lang.columns[4]}`)">
                <div style="display: flex; align-items: center">
                  <img style="width: 22px; height: 22px; margin-right: 12px" src="../assets/banktran.png" alt="##" />
                  <div>
                    <div>{{ lang.columns[4] }}</div>
                    <div style="font-size: 12px; margin-top: 8px">{{ lang.transferFake }}</div>
                  </div>
                </div>
                <van-radio checked-color="#ED1818" :name="lang.columns[4]"></van-radio>
              </div>
            </van-radio-group>
          </div>
          <!-- <van-field readonly clickable :label="lang.payment_way" :value="value" @click="selectType" input-align="right" />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar :columns="lang.columns" @cancel="showPicker = false" @confirm="onConfirm" :confirm-button-text="lang.confirm" :cancel-button-text="lang.cancel" />
          </van-popup> -->
        </div>
      </div>
      <!-- 確定按鈕 -->
      <div class="btn">
        <van-button @click="confirm" class="confirm" size="large" :disabled="!setId || this.value.trim().length <= 0">{{ lang.confirm }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import pub from '../../common/public';
import '../../common/css/common.scss';
// import { Row, Col, Popup, Toast, Dialog } from 'vant';
import lang from './../../common/language/topup';
export default {
  name: 'storedValueMoney',
  data() {
    return {
      isShowPage: false,
      isPc: false,
      lang: { ...lang, info: [], star: [] },
      radio: lang.columns[0],
      index: -1,
      list: [],
      payMethod: '',
      setId: null,
      moneyNum: {},
      value: '',
      showPicker: false,
      paytype: '',
      post: false, // 判断 是否从刊登楼盘页面 进入刊登
      // coinHiden:false
      pay: [
        {
          img: require('../assets/postCard.png'),
          text: lang.columns[0],
          id: 3,
          attr: 'paydollar',
        },
        {
          img: require('../assets/pay01.png'),
          text: `(${lang.columns[1]})`,
          id: 0,
          attr: 'paypal',
        },
        {
          img: require('../assets/banktran.png'),
          text: lang.columns[2],
          id: 2,
          attr: 'trans',
        },
      ],
      isAliPay: true, //支付宝的支付开关
      isWePay: true, // 微信的支付开关
    };
  },
  // watch:{
  //   $route(to, from) {
  //     console.log("storede",from)
  //   }
  // },
  created() {
    this.isPc = !(document.body.clientWidth <= 750 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()))
    const ua = navigator.userAgent.toLowerCase();
    const platform = ua.indexOf('house730') > -1 ? 'app' : '';
    if (platform == 'app') {
      const sys = ua.indexOf('iphone') > -1 || ua.indexOf('ios') > -1 ? 'ios' : 'android';
      if (sys == 'ios') {
        this.isAliPay = true;
        this.isWePay = false;
      } else {
        this.isAliPay = true;
        this.isWePay = false;
      }
    } else {
      this.isAliPay = true;
        this.isWePay = false;
    }
    if (this.isPc) {
      if (pub.getLang() === 'zh-cn') {
        location.href = `${pub.config.pcPassport}zh-cn/propertycoinmanage/`;
      } else if (pub.getLang() === 'en-us') {
        location.href = `${pub.config.pcPassport}en-us/propertycoinmanage/`;
      } else {
        location.href = `${pub.config.pcPassport}propertycoinmanage/`;
      }
    } else {
      this.isShowPage = true;
    }
    this.getMoneyNum();
    this.getMoneyDiscounts();
    // this.value = this.lang.columns[0];
    this.value = this.radio;
    this.post = this.$route.query.from == 'post';
    let temp = this.$route.query.page;
    const flag = sessionStorage.getItem('flag');
    console.log('created', this.$route, '2k344', flag);

    if (this.$route.query.page === 1 && flag) {
      this.$dialog
        .alert({
          title: lang.succeed,
          className: 'pay-info',
          confirmButtonText: lang.confirm,
          message: this.lang.pay_success,
        })
        .then(() => {
          if (this.post) {
            this.$router.push(`/post/pay?id=${this.$store.state.propertyInfo.propertyID}&type=1`);
          }
        });
    }
  },
  mounted() {
    this.list = this.lang.list;
    //  if (this.$route.query.version&&this.$route.query.platfrom=='ios') {
    //   this.pub.getAppConfig(this.version).then(res => {
    //     this.coinHiden = res // true 隐藏金币支付
    //   });
    // }
    // 监听浏览器的返回按钮
    if (window.history && window.history.pushState) {
      if (!this.$route.query.fromapp) {
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', this.goBack, false);
      }
    }
  },
  destroyed() {
    this.$dialog.close();
    window.removeEventListener('popstate', this.goBack, false);
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/' });
    },
    changeRad(payradio) {
      this.radio = payradio;
    },
    radioChange() {
      this.value = this.radio;
    },
    selectType() {
      // console.log(this.coinHiden)
      // if(this.coinHiden)return;
      // else
      // liulei0903 7天后改外true
      this.showPicker = true;
      // this.showPicker = false;
    },

    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
    getMoneyNum() {
      this.axios.get(this.pub.getApi().SearchPropertyCoinSet).then((res) => {
        // console.log(res);
        const { data, status } = res;
        if (status == 200) {
          this.lang.list = data.result.sort((a, b) => {
            return a.propertyCoin - b.propertyCoin;
          });
        }
      });
    },
    // 获取优惠价格
    getMoneyDiscounts() {
      this.axios.get(this.pub.getApi().SearchPropertyPriceSet).then((res) => {
        const { data, status } = res;
        if (status == 200) {
          this.lang.info = data.result.filter((item) => {
            return item.itemName === 'Normal';
          });
          this.lang.star = data.result.filter((item) => {
            return item.itemName.startsWith('Star');
          });
          console.log(this.lang.star);
        }
      });
    },
    onClickLeft() {
      //* paydollar支付成功跳转回到
      if (this.$route.query.paytype == 'success') {
        this.$router.push({ path: '/' });
      } else {
        this.$router.push({ path: '/' });
      }
      // if (this.post) {
      //   this.$router.push(`/post/pay?id=${this.$store.state.propertyInfo.propertyID}&type=1`);
      // } else {
      //   this.$router.push({ path: '/' });
      // }
    },
    son(item, idx) {
      this.index = idx;
      this.setId = item.setID;
      this.moneyNum = item;
    },
    confirm() {
      // this.masge =
      //   this.lang.select_money +
      //   this.moneyNum.propertyCoin +
      //   this.lang.wu_money +
      //   "(" +
      //   this.lang.select_sost +
      //   this.moneyNum.money +
      //   ")";
      // this.payment_before = true;
      // this.infoted = true;
      // this.footered = true;
      this.gold = this.lang.unit + '：' + this.moneyNum.propertyCoin;
      if (this.value == 'paydollar') {
        this.way = this.lang.payment_way + '：' + this.lang.pdCre;
      } else {
        this.way = this.lang.payment_way + '：' + this.value;
      }
      this.total = this.lang.rental + '：' + 'HK$' + this.moneyNum.money;
      const fromapp = this.$route.query.fromapp;

      this.$dialog
        .confirm({
          title: lang.hint,
          className: 'pay-info',
          confirmButtonText: lang.confirm,
          cancelButtonText: lang.cancel,
          message: this.gold + '\n' + this.way + '\n' + this.total + '\n' + this.lang.next,
        })
        .then(() => {
          this.axios
            .post(this.pub.getApi().AddPropertyCoinOrder, {
              coinId: this.setId,
            })
            .then((res) => {
              // console.log(res);
              if (res.data.code === 0) {
                if (this.value === this.lang.columns[1]) {
                  this.$router.push(`/pay?orderid=${res.data.result}&type=paypal${fromapp ? '&fromapp=' + fromapp : ''}&source=coin${this.post ? '&form=post' : ''}`);
                } else if (this.value === this.lang.columns[0]) {
                  this.$router.push(`/pay?orderid=${res.data.result}&type=paydollar${fromapp ? '&fromapp=' + fromapp : ''}&source=coin${this.post ? '&form=post' : ''}`);
                } else if (this.value === this.lang.columns[2]) {
                  this.$router.push(`/pay?orderid=${res.data.result}&type=lpay${fromapp ? '&fromapp=' + fromapp : ''}&source=coin${this.post ? '&form=post' : ''}`);
                } else if (this.value === this.lang.columns[3]) {
                  this.$router.push(`/pay?orderid=${res.data.result}&type=wpay${fromapp ? '&fromapp=' + fromapp : ''}&source=coin${this.post ? '&form=post' : ''}`);
                } else {
                  this.$router.push(`/pay?orderid=${res.data.result}&type=transfer${fromapp ? '&fromapp=' + fromapp : ''}&soure=coin${this.post ? '&form=post' : ''}`);
                }
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style lang="scss" scoped>
html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.content {
  width: 100%;
  overflow: hidden;
  .table {
    width: 90%;
    margin: 5%;
    background-color: #fff;
    border: 1px solid #f3f3f3;
    display: table;
    .center {
      margin: 5px 0px;
    }
    tr th {
      height: 40px;
      line-height: 40px;
      background-color: #f5f6f7;
      border: 1px solid #f3f3f3;
    }
    tr td {
      height: 60px;
      display: table-cell;
      vertical-align: middle;
      background-color: #fff;
      border: 1px solid #f3f3f3;
      font-size: 14px;
    }
    tr .time {
      line-height: 25px;
    }
  }
  .interval {
    width: 100%;
    height: 20px;
    background-color: #f5f6f7;
  }
  .bottom {
    padding: 5%;
    text-align: left;
    h3 {
      font-weight: bold;
      color: #000;
      line-height: 30px;
    }
    & > .num {
      line-height: 50px;
    }
    .number1 {
      padding: 10px 20px;
      background-color: #000;
      color: #fff;
      margin-right: 10px;
    }
    ul {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      text-align: center;
      // padding: 15px;
      li {
        width: 30%;
        height: 60px;
        padding: 5px;
        margin-bottom: 10px;
        border: 1px solid #f3f3f3;
        box-sizing: border-box;
        font-size: 14px;
        .info {
          line-height: 27.5px;
        }
      }
      .selected {
        border: 1px solid red;
        color: red;
      }
    }
    & > .payment {
      line-height: 50px;
    }
    .number2 {
      padding: 10px 20px;
      background-color: #000;
      color: #fff;
      margin-right: 10px;
    }
    .select {
      .seltit {
        font-size: 14px;
        font-weight: 700;
        color: #333333;
        margin-top: 12px;
        margin-bottom: 12px;
      }
      .pdBox {
        // li {
        //   width: 100%;
        //   font-size: 14px;
        //   color: #333333;
        //   display: flex;
        //   flex-direction: row;
        //   justify-content: space-between;
        //   border-bottom: 1px solid #ededed;
        //   height: 50px;
        //   line-height: 50px;
        //   img {
        //     margin: 0 4px -5px 0;
        //   }
        //   .palimg {
        //     margin-top: 18px;
        //     height: 16px;
        //   }
        //   /deep/.van-radio__icon .van-icon {
        //     height: 16px;
        //     width: 16px;
        //     border: 1px solid #979797;
        //   }
        // }
        .pdFlex {
          font-size: 14px;
          color: #333333;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          border-bottom: 1px solid #ededed;
          height: 50px;
          align-items: center;
          // line-height: 50px;
          img {
            margin: 0 4px -5px 0;
          }
          .palimg {
            // margin-top: 18px;
            height: 16px;
          }
          /deep/.van-radio__icon .van-icon {
            height: 16px;
            width: 16px;
            border: 1px solid #979797;
          }
          /deep/.van-radio__icon,
          .van-radio__label {
            line-height: 17px;
          }
        }
      }
    }
  }
  .btn {
    width: 100%;
    height: 60px;
    background-color: #001a33;
    overflow: hidden;
    .confirm {
      width: 90%;
      height: 40px;
      line-height: 40px;
      margin-top: 10px;
      color: #fff;
      background-color: #ed1c24;
      border: none;
    }
  }
}

.ali-text {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #333;
}
.pos {
  position: relative;
  left: -3px;
}
.van-radio {
  width: 21px!important;
}
</style>
